<template>
    <span
        class="kgr-icon kgr-icon--circle kgr-icon--small kgr-icon--basfi"
        :class="iconClass"
        :title="title"
    ><span>{{ type }}</span>
    </span>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
    },
    computed: {
        iconClass() {
            switch(this.type) {
                case 'I':
                    return 'kgr-icon--success';
                case 'W':
                    return 'kgr-icon--warning';
                case 'E':
                    return 'kgr-icon--error';
                default:
                    return '';
            }
        },
    },
    methods: {
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .kgr-icon--basfi span {
        font-size: small;
        text-align: center;
        width: 100%;
        display: inline-block;
        vertical-align: top;
    }
    .kgr-icon--success {
        background-color: green
    }
</style>
